import React, { useEffect, useState } from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex?.drawer + 1,
    color: "#1c75bb",
  },
}));

const CircularProgressBar = (props) => {
  const classes = useStyles();
  const [isloading, setIsloading] = useState(false);

  useEffect(() => {
    setIsloading(props.isloading || false);
  }, [props]);
  return (
    <Backdrop className={classes.backdrop} open={isloading}>
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};

export default CircularProgressBar;
